import { Navigate, useSearchParams } from 'react-router-dom'

import BidDetailHeader from '@/features/bidding/components/bidDetail/BidDetailHeader'
import BidDetailTabs from '@/features/bidding/components/bidDetail/BidDetailTabs'
import BidEnergyView from '@/features/bidding/components/bidDetail/energy/BidEnergyView'
import { BidType } from '@/features/bidding/constants'
import { useBidDetailRouteParams } from '@/features/bidding/hooks/bidDetail/useBidDetailRouteParams'
import NavigateToError from '@/features/error/pages/NavigateToError'

/**
 * Top-level page for the new bid detail route `/bidding/:marketProgram/:bidType`.
 */
export default function BidDetailPage() {
  const params = useBidDetailRouteParams()
  const [searchParams] = useSearchParams()

  if (!params) {
    return <NavigateToError statusCode={404} />
  }

  const { marketProgram, bidType } = params

  // TEMPORARY: the capacity view isn't built yet — redirect capacity to the
  // Bid Versions page (/bidding/view). Remove once the capacity view lands.
  if (bidType === BidType.CAPACITY) {
    const viewParams = new URLSearchParams(searchParams)
    viewParams.set('marketProgram', marketProgram)
    viewParams.set('bidType', bidType)

    return <Navigate replace to={`/bidding/view?${viewParams.toString()}`} />
  }

  return (
    <>
      <BidDetailHeader />
      <BidDetailTabs bidType={bidType} marketProgram={marketProgram} />
      <BidEnergyView marketProgram={marketProgram} />
    </>
  )
}
